import { Component, OnInit, Inject, ViewChild, AfterViewInit, OnDestroy, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatInput, MatExpansionPanel } from '@angular/material';
import { UserGroupService } from '../../../../../../core/services/user-group.service';
import { MatDialogRef } from '@angular/material';
import { ReplaySubject, Subject, Subscription } from 'rxjs';
import { FormControl, NgForm } from '@angular/forms';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { NotificationService } from 'src/app/core/services/notification.service';
import { DeactivationGuarded } from 'src/app/core/guards/confirm-deactivate.guard';
import { map, first, takeUntil } from 'rxjs/operators';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/core/services/common.service';

@Component({
  selector: 'app-update-user-group',
  templateUrl: './update-user-group.component.html',
  styleUrls: ['./update-user-group.component.scss']
})
export class UpdateUserGroupComponent implements OnInit, AfterViewInit, OnDestroy, DeactivationGuarded {
  featuresGroups: any;
  features: any;
  dataRole: any;
  digitalStatus;
  subSignPermission: any;
  subManagerPermission: any;
  signPermission: any;
  managerPermission: any;
  checkAll = false;
  permissionInGroup: any;
  isFormChanging = false;
  formChangesSubscription: Subscription;
  change = false;
  checkEscKey = false;
  grDefualt = {
    featureGroupIds: [],
    managerPermissionServiceType: [],
    signPermissionServiceTypes: [],
    managerServiceTypeFeatureGroupId: '',
    signServiceTypeFeatureGroupId: '',
    name: '',
    description: '',
    permissions: null,
    version: null
  };
  grUs = this.grDefualt;
  oldGroupName;

  isMultiCreateUserGroup = false;
  urlApi = '/users/group-user';

  checkFocus = true;
  serviceTypes: comboBox[] = [];
  serviceTypePermission = [];
  newServiceTypePermission = [];
  showCreateSideError = false;

  public filteredServiceTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);

  serviceTypesFilterCtrl: FormControl = new FormControl();
  private _onDestroy = new Subject<void>();

  @ViewChild('customPanel', {static: false}) panel: MatExpansionPanel;
  @ViewChild('togglePanelButton', {static: false}) togglePanelButton: ElementRef;
  @ViewChild('f', { static: false }) ngForm: NgForm;
  @ViewChild('focusInput', { static: false }) focusInput: MatInput;

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (!this.checkEscKey) {
      this.onClickBtnCancel();
    }
  }

  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
    }
  }

  constructor(
    private el: ElementRef,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userGroupService: UserGroupService,
    private dialogRef: MatDialogRef<UpdateUserGroupComponent>,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    private message: Message,
    private toastr: ToastrService,
    public commonService: CommonService,
    private renderer: Renderer2
  ) {
    dialogRef.disableClose = true;
    dialogRef.backdropClick().subscribe(_ => {
      this.onClickBtnCancel();
    });

    const digitalFeature = JSON.parse(localStorage.getItem('featureStatus'));
    digitalFeature.map(item => {
      if (item.permission === 10) {
        this.digitalStatus = item.status;
      }
    });
  }

  ngOnInit() {
    this.serviceTypesFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(
            () => {
              this.commonService.filterCertificateType(this.serviceTypes, this.serviceTypesFilterCtrl, this.filteredServiceTypes);
            });

    this.getServiceTypeByEnterprise();

    this.loadData();
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focusInput.focused = true);
    this.formChangesSubscription = this.ngForm.form.statusChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
  }

  /**
   * Update data
   */
  onUpdate() {
    if (this.isFormChanging || this.change) {
      // if(!this.checkCreateSideValid()) {
      //   this.showCreateSideError = true;
      //   document.getElementById("createSideOption").scrollIntoView();
      //   this.panel.open();
      //   return
      // }
      const dialogRef = this.dialog.open(WarningComponent, {
        width: '350px',
        // them ten nhom nguoi dung
        data: this.commonService.format(this.message.getMessage('messages.confirm_update_usGr'), this.oldGroupName)
      });
      dialogRef.afterClosed().subscribe(rs => {
        if (rs) {
          const dataUpdate = {
            name: this.grUs.name,
            description: this.grUs.description,
            id: this.data.data,
            version: this.grUs.version,
            // enterpriseId: localStorage.getItem('enterpriseId'),
            // featureGroupIds: this.getPermission(),
            // signPermissionServiceTypes: this.getSubSignPermission(),
            // managerPermissionServiceType: this.getManagerPermissionServiceType()
          };
          this.userGroupService.updateUserGroup(
            dataUpdate,
            () => {
              this.toastr.success(this.message.getMessage('user_group.update_success'));
              this.dialogRef.close();
            },
            () => {
              this.loadData();
            },
            this.onUpdateUserGroupError.bind(this)
          );
        }
      });
    } else {
      this.dialogRef.close();
    }
  }

  private onUpdateUserGroupError(rs: any) {
    if (!rs.success) {
      if (rs.code == '0x00604') {
        this.ngForm.form.controls.name.setErrors({ invalid: true, duplicate: true });
        document.getElementById('name').focus();
      }
    }
  }

  /**
   * Load data to update
   */
  loadData() {
    this.userGroupService.getGroupUserById(this.data.data).subscribe(rs => {
      if (rs != null && rs.data != null) {
        this.grUs = rs.data;
        this.loadFuture();
        this.oldGroupName = rs.data.name;
        this.serviceTypePermission = rs.data.managerPermissionServiceType;
      } else {
        this.grUs = this.grDefualt;
      }
    });
  }

  /**
   * Get permission
   */
  getPermission() {
    let tempRole: any;
    tempRole = this.dataRole.filter(role => {
      return role.active;
    });
    tempRole = tempRole.map(item => {
      return item.id;
    });
    return tempRole;
  }

  /**
   * Load all feature from server
   */
  async loadFuture() {
    this.features = await this.userGroupService.getAllFeatures().toPromise();
    this.subSignPermission = await this.userGroupService.getServiceType(localStorage.getItem('enterpriseId')).toPromise();
    this.featuresGroups = await this.userGroupService.getAllFeaturesGroups().toPromise();
    this.permissionInGroup = this.grUs.featureGroupIds;
    this.signPermission = this.grUs.signPermissionServiceTypes;
    this.mapGroupUser();
  }

  /**
   * Map feature to show
   */
  mapGroupUser() {
    let isParentEnterprise = localStorage.getItem('isParent');
    this.dataRole = this.featuresGroups.data.map(feGr => {
      feGr.active = false;
      if (this.permissionInGroup != null && this.permissionInGroup.length > 0) {
        let data: any;
        data = this.permissionInGroup.filter(per => {
          return per === feGr.id;
        });
        if (data.length > 0) {
          feGr.active = true;
        }
      }

      /**
       * Map id to get feature to show Manager document
       */
      if (feGr.id === this.grUs.signServiceTypeFeatureGroupId && this.subSignPermission
        && this.subSignPermission.data && this.subSignPermission.data.length > 0) {
        feGr.subSignPermission = this.subSignPermission.data.map(sub => {
          if (this.signPermission != null && this.signPermission.length > 0) {
            let data: any;
            data = this.signPermission.filter(sb => {
              return sb === sub.id;
            });

            if (data.length > 0) {
              sub.active = true;
            }
          }
          return sub;
        });
        feGr.active = feGr.subSignPermission.every((item: { active: any }) => {
          return item.active;
        });
      }

      feGr.child = this.features.data.filter(fe => {
        if (fe.code !== 'ae.qlttnd.cnttdn') {
          if (isParentEnterprise) {
            return fe.featureGroupId === feGr.id;
          } else {
            if (fe.code !== 'ae.qlttdn.qlttcn' && fe.code !== 'ae.qlttdn.qlldv') {
              return fe.featureGroupId === feGr.id;
            } else {
              return false;
            }
          }
        } else {
          return false;
        }
        // return fe.featureGroupId === feGr.id && fe.code !== 'ae.qlttnd.cnttdn';
      });

      return feGr;
    }).filter(r => r.code !== 'ae.qldmtl' && r.code !== 'ae.kstl');

    const digitalGr = this.dataRole.filter(item => item.code === 'ae.qlshhd');
    if (this.digitalStatus === false) {
      this.dataRole.splice(this.dataRole.indexOf(digitalGr), 1);
    }
    // trừ đi 2 thằng 'ae.qldmtl' && 'ae.kstl'
    if ((this.featuresGroups.data.length - 2) === this.permissionInGroup.length) {
      this.checkAll = true;
    }
    let createSideFeGrIndex = -1;
    let receiveSideFeGrIndex = -1;
    this.dataRole.forEach((feGr, index) => {
      if (feGr.code === "ae.qlhdct") {
        createSideFeGrIndex = index;
      }
      if (feGr.code === "ae.qlhddt") {
        receiveSideFeGrIndex = index;
      }
    });
    if (createSideFeGrIndex > -1 && receiveSideFeGrIndex > -1) {
      const tempFeGr = this.dataRole[createSideFeGrIndex];
      this.dataRole[createSideFeGrIndex] = this.dataRole[receiveSideFeGrIndex];
      this.dataRole[receiveSideFeGrIndex] = tempFeGr;
    }
  }

  /**
   * Event when click button cancel
   */
  onClickBtnCancel() {
    if (this.isFormChanging || this.change) {
      this.checkEscKey = true;
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
        this.checkEscKey = false;
      });
    } else {
      this.dialogRef.close();
    }
  }

  /**
   * Handle when click check all icon
   */
  checkAllRole() {
    this.dataRole.map(roleGr => {
      this.checkAll ? roleGr.active = true : roleGr.active = false;
      return roleGr;
    });
  }

  /**
   * Confirm before navigation
   */
  canDeactivate() {
    if (!this.isFormChanging) {
      return true;
    } else {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      return dialogRe.afterClosed().pipe(map(result => {
        if (result) {
          return true;
        } else {
          return false;
        }
      }), first());
    }
  }

  /**
   * Check data change in sub permission
   */
  subSignChange(group: any) {
    group.active = group.subSignPermission.every((item: { active: any }) => {
      return item.active;
    });
    this.verifyCheckAllStage();
    this.change = true;
  }

  /**
   * Handle when click check all icon
   */
  checkAllPermission() {
    this.dataRole.map(item => {
      item.active = this.checkAll;
      if (item.subSignPermission) {
        item.subSignPermission.map(subitem => subitem.active = this.checkAll);
      }
      if (item.subManager) {
        item.subManager.map(subitem => subitem.active = this.checkAll);
      }
      return item;
    });
  }

  /**
   * Handle change permission
   */
  permissionChanged(id: string) {
    const permission = this.dataRole.find((item: { id: string; }) => item.id === id);
    if (id === this.grUs.signServiceTypeFeatureGroupId && permission.subSignPermission) {
      permission.subSignPermission.map((item: { active: boolean; }) => {
        permission.active ? item.active = true : item.active = false;
      });
    }

    /* remove service type permission list when uncheck create */
    if (id === this.grUs.managerServiceTypeFeatureGroupId && !permission.active) {
      this.serviceTypePermission = [];
      this.newServiceTypePermission = [];
    }

    this.verifyCheckAllStage();
  }

  /**
   * Verify check all
   */
  verifyCheckAllStage() {
    this.checkAll = this.dataRole.every((item: { active: any; }) => {
      return item.active;
    });
    this.change = true;
  }

  /**
   * Get sub permission for sign document
   */
  private getSubSignPermission() {
    let tempRole: any;
    this.dataRole.map(x => {
      if (x.id === this.grUs.signServiceTypeFeatureGroupId && x.subSignPermission) {
        tempRole = x.subSignPermission.filter(rs => {
          return rs.active;
        });
        tempRole = tempRole.map(item => {
          return item.id;
        });
        return tempRole;
      } else {
        tempRole = [];
      }
    });
    return tempRole;
  }

  getServiceTypeByEnterprise() {
    const enterpriseId = localStorage.getItem('enterpriseId');
    this.commonService.getEnterpriseServiceType(enterpriseId).subscribe(rs => {
      if (rs && rs.data) {
        this.serviceTypes = rs.data;
        this.filteredServiceTypes.next(rs.data.slice());
        /* set gias tri service type */
        // this.serviceTypePermission = parseInt(this.serviceTypePermission);
      }
    });
  }

  getManagerPermissionServiceType(): any[] {
    console.log("service type permission o day", this.newServiceTypePermission);
    return this.newServiceTypePermission;
  }

  updateServiceTypePermission(serviceTypePermission: any[]) {
    if (serviceTypePermission != null) {
      this.newServiceTypePermission = [...serviceTypePermission];
      const orderNew = [...this.newServiceTypePermission].sort((a,b) => a - b);
      const orderOld = [...this.serviceTypePermission].sort((a,b) => a - b);
      let serviceTypeChange = false;
      if(orderNew.length === orderOld.length) {
        for(let i = 0; i < orderNew.length; i++) {
          if(orderNew[i] !== orderOld[i]) {
            serviceTypeChange = true;
            break;
          }
        }
      } else {
        serviceTypeChange = true;
      }
      if (serviceTypeChange === true && this.isFormChanging === false) {
        this.isFormChanging = true;
      }
      if(serviceTypePermission.length > 0) this.showCreateSideError = false;
    }
  }

  togglePanel() {
    this.panel.toggle();
    this.renderer.setStyle(this.togglePanelButton.nativeElement, 'transform', `rotate(${this.panel.expanded ? '180' : '0'}deg)`)
  }

  /* If select create side contract permission then required at least 1 service type selected */
  checkCreateSideValid() {
    const createSidePermissionSelected = this.dataRole.find(fGr => fGr.active === true && fGr.code === 'ae.qlhdct');
    const serviceTypeId = this.getManagerPermissionServiceType();
    return !(createSidePermissionSelected && serviceTypeId.length === 0)
  }
}
